import CloseIcon from '@kijiji/icons/src/icons/Close'
import { HTMLAttributes } from 'react'

import { StyledModalCloseButton } from '@/ui/molecules/modal/styled'

type Props = HTMLAttributes<HTMLButtonElement>

export const ModalCloseButton = ({ ...props }: Props) => {
  return (
    <StyledModalCloseButton {...props}>
      <CloseIcon />
    </StyledModalCloseButton>
  )
}
